export var NetworkMode;
(function (NetworkMode) {
    NetworkMode[NetworkMode["JSWebSockets"] = 0] = "JSWebSockets";
    NetworkMode[NetworkMode["LocalWorkflowsOnly"] = 1] = "LocalWorkflowsOnly";
    NetworkMode[NetworkMode["HostWebSockets"] = 2] = "HostWebSockets";
})(NetworkMode || (NetworkMode = {}));
//# sourceMappingURL=messages-shared.js.map